import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import {
  ILabelValuePanel,
  ISmartSwitchDeviceErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAirConnectStatusCount from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';
import { SmartSwitchErrorIcon } from '../../../../../../../../assets/dashboard';

export interface SmartSwitchDeviceErrorPanelProps {
  panel: ISmartSwitchDeviceErrorPanel;
  layout?: LayoutItem | undefined;
}

function SmartSwitchDeviceErrorPanel(props: SmartSwitchDeviceErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isLoading, currentData, error } = useAirConnectStatusCount(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `smartswitch_device_error`,
    title: panel.title,
    icon: <SmartSwitchErrorIcon height={'100%'} />,
    content: (
      <DefaultRightContainer success={currentData?.shellyRemoved === 0}>
        {currentData?.shellyRemoved ?? 0}
      </DefaultRightContainer>
    ),
    loading: isLoading,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default SmartSwitchDeviceErrorPanel;
